import { content } from "../../data/siteData";

const AboutSection = ({ locale }) => {
  const { about: t, stats } = content[locale];

  return (
    <section
      id="about-me"
      className="w-full py-16 md:py-24 px-6 md:px-12 bg-white"
    >
      <div className="max-w-7xl mx-auto flex flex-col gap-10 md:gap-16">
        <h2 className="font-poppins font-extralight text-4xl md:text-5xl lg:text-[64px] text-[#333333] text-left leading-none">
          {t.heading}
        </h2>

        <div className="grid md:grid-cols-2 gap-10 md:gap-16">
          <div className="flex flex-col gap-6 md:gap-8">
            <p className="font-poppins font-light text-xl md:text-2xl text-[#333333] leading-relaxed">
              {t.lead}
            </p>
            {t.paragraphs.map((paragraph) => (
              <p
                key={paragraph}
                className="font-poppins font-light text-base md:text-xl text-[#555555] leading-relaxed"
              >
                {paragraph}
              </p>
            ))}
            <a
              href="/resume.pdf"
              download
              className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 bg-[#333333] text-white font-poppins font-light text-base md:text-lg rounded-lg hover:bg-[#555555] transition-colors self-start focus:outline-none focus:ring-2 focus:ring-[#333333] focus:ring-offset-2"
              aria-label={t.resumeLabel}
            >
              <svg
                className="w-4 h-4 md:w-5 md:h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
              {t.resume}
            </a>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-8">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="flex flex-col items-center justify-center p-6 md:p-8 bg-[#f5f5f5] rounded-lg hover:shadow-md transition-shadow"
              >
                <p className="font-montserrat font-bold text-3xl md:text-4xl lg:text-5xl text-[#333333]">
                  {stat.value}
                </p>
                <p className="font-poppins font-light text-sm md:text-lg text-[#555555] mt-2">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
